/**
 * Display a phone number without exposing raw digit soup.
 * US/Canada 10-digit or leading-1 11-digit → +1 (251) 583-3107
 * Anything else with 8+ digits → + and the digits (international).
 */
export function formatPhoneDisplay (raw) {
  const original = String(raw || '').trim()
  if (!original) {
    return ''
  }
  const digits = original.replace(/\D/g, '')
  if (!digits) {
    return original
  }

  if (digits.length === 10) {
    return '+1 (' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6)
  }
  if (digits.length === 11 && digits.charAt(0) === '1') {
    const d = digits.slice(1)
    return '+1 (' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6)
  }
  if (digits.length >= 8) {
    return '+' + digits
  }
  return original
}
